import { Button, LinkButton } from "@/ui/Button";
import { Orb } from "@/ui/Orb";
import { Screen } from "@/ui/Screen";
import { Display, Label } from "@/ui/Text";

interface SplashProps {
  readonly onStart: () => void;
  readonly onSignIn: () => void;
}

/**
 * The open. The mark arrives before its own name — the orb is the object the
 * whole product is built around, and it earns the first beat.
 */
export function Splash({ onStart, onSignIn }: SplashProps) {
  return (
    <Screen
      centred
      foot={
        <>
          <Button label="Get started" onClick={onStart} />
          <LinkButton label="I already have an account" onClick={onSignIn} />
        </>
      }
    >
      <Orb size={116} floating />
      <Display size="xl" className="mt-11">
        Antar
      </Display>
      <Label className="mt-3">Think it through out loud</Label>
    </Screen>
  );
}
